<template>
  <div class="comp-drop-target"
    v-bind:class="dataId"
    v-bind:id="droppable.id"
    v-bind:style="{
      top: droppable.position.top + '%',
      left: droppable.position.left  + '%',
      height: droppable.position.height  + '%',
      width: droppable.position.width  + '%',
      backgroundImage: (droppable.imagePath !== '') ? 'url(' + require('../../assets/' + droppable.imagePath) + ')' : none
    }"
  >
    <div class="active-wrap"
      v-bind:style="{ backgroundImage: 'url(' + require('../../assets/' + droppable.active_imagePath) + ')' }"
    >
    </div>
    <div v-if="droppable.content.length === -1">
      <div class="drag-wrap"
      v-for="(draggable, index) in droppable.content"
      v-bind:key="index"
      v-bind:style="{ backgroundImage: 'url(' + require('../../assets/' + draggable.imagePath) + ')' }"
      >
        <span>{{draggable.label}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import 'jquery-ui/ui/widgets/draggable'
import 'jquery-ui/ui/widgets/droppable'
import { focus } from 'vue-focus'

export default {
  name: 'DropTarget',
  directives: { focus: focus },
  data () {
    return {
      showDrop: false,
      initFocus: false,
      secFocus: false,
      lastFocus: false
    }
  },
  props: {
    dataId: {
      type: String,
      required: true
    },
    dataKey: {
      type: String,
      required: true
    }
  },
  watch: {
    lastFocus () {

    }
  },
  computed: {
    content () {
      return this.$store.getters.getData(this.dataId)
    },
    droppable () {
      return this.content.data.droppables[this.dataKey]
    },
    draggables () {
      return this.content.data.draggables
    }
  },
  mounted () {
    $(this.$el).droppable({
      accept: (element) => {
        let acceptedKeys = this.droppable.accepted_keys
        for (let i = 0; i < acceptedKeys.length; i++) {
          if (element.data('id') === acceptedKeys[i]) {
            return true
          }
        }
        return false
      },
      classes: {
        'ui-droppable-active': 'comp-drop-target-active'
        // 'ui-droppable-hover': 'drop-active'
      },
      drop: (event, ui) => {
        let dragKey = $(ui.draggable).data('id')
        this.triggerDrop(dragKey)
      }
    })
  },
  created () {
    this.$eventHub.$on('tab-pressed', () => {

    })
  },
  methods: {
    triggerDrop (dragKey) {
      let dragObj = this.draggables[dragKey]
      this.draggables[dragKey].isDropped = true
      this.droppable.content.push(dragObj)
      this.$emit('componentDrop', dragKey)

      delete this.draggables[dragKey]
    },
    checkAnswer () {
      let acceptedKeys = this.droppable.accepted_keys
      let content = this.droppable.content

      if (acceptedKeys.length === content.length) {
        this.droppable.completeAnswer = true
      }
      this.$emit('componentDrop')
      // this.checkAnswerCount()
    },
    checkAnswerCount () {
      let droppables = this.content.data.droppables
      for (var key in droppables) {
        let dropData = droppables[key]
        if (dropData.completeAnswer === false) {
          this.content.data.isComplete = false
          break
        } else {
          this.content.data.isComplete = true
        }
      }
      console.log(this.content.data.isComplete)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style src="./style.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/droppable-target/DroppableTarget.vue